import { useState } from "react";
import { MessageSquare, CheckCheck } from "lucide-react";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "../ui/dialog";
import { smsHref } from "./leadUtils";

export const SmsDialog = ({ open, onOpenChange, phone, initialMessage, title = "Send Text Message", onLogged }) => {
  const [message, setMessage] = useState(initialMessage || "");
  const [logging, setLogging] = useState(false);

  const logSent = async () => {
    setLogging(true);
    try {
      await onLogged(message);
      onOpenChange(false);
    } finally {
      setLogging(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border-zinc-800 text-white max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading">{title}</DialogTitle>
        </DialogHeader>
        <p className="text-zinc-500 text-xs -mt-2">To: {phone}. Edit the message, open it in your messaging app, then log it as sent.</p>
        <Textarea
          data-testid="sms-dialog-message"
          className="bg-[#0a0a0a] border-zinc-800 text-white rounded-sm h-40 text-sm"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <a
            data-testid="sms-dialog-open-messages"
            href={smsHref(phone, message)}
            className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            <MessageSquare className="h-4 w-4" /> Open in Messages
          </a>
          <button
            data-testid="sms-dialog-log-sent"
            onClick={logSent}
            disabled={logging}
            className="inline-flex items-center justify-center gap-2 border border-zinc-700 hover:border-zinc-500 disabled:opacity-60 text-white rounded-sm px-5 py-2.5 text-sm font-semibold transition-colors"
          >
            <CheckCheck className="h-4 w-4" /> Log as Sent
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
